export const en = {
  onboardingPage: {
    companyDoesNotExistModal: {
      title: "We couldn't find your company",
      message:
        'Is your company interested in signing up for Purposely? Book a demo to learn more!',
      buttons: {
        confirm: 'Book a Demo',
        cancel: 'Back',
      },
    },
    employeeLanding: {
      title: 'Employee Landing Page',
      benefits: {
        contribute:
          'Contribute to your community and the causes you care about',
        learn: 'Learn new skills',
        share: 'Share your skills',
        activities:
          'Do fun activities with your coworkers that also benefit your community',
        connect: 'Meet new people',
      },
      links: {
        signup: 'Get Started',
        login: 'Log in',
      },
    },
    causes: {
      title: 'Cause Preferences',
      subtitle:
        'Which causes are you most interested in supporting through volunteering?',
      hint: 'To help us personalize your experience, we recommend selecting a maximum of 5 causes',
      buttons: {
        next: 'Next',
      },
      validation: {
        max_causes: 'Please select no more than 5 causes',
      },
    },
    companyDoesNotExist: {
      title:
        "We couldn't find a company that uses your email domain. But don't lose hope.",
      options: {
        wrong_email:
          'If you are an employee of a company using purposely but you used the wrong email, ',
        wrong_email_link: 'try again using your work email.',
        nonprofit: 'If you are a nonprofit, ',
        nonprofit_link: 'create a nonprofit account here.',
        company_benefit:
          'If you think your company could benefit from using Purposely, ',
        company_benefit_link: 'connect us with your people.',
        register: 'If you want to register your company with Purposely, ',
        register_link: 'book a demo',
      },
    },
    generalInfoForm: {
      labels: {
        profile_photo: 'Profile Photo',
        full_name: 'Full Name',
        department: 'Department',
        location: 'Location',
        team_lead: 'Do you manage or lead a team at {{companyName}}?',
        preferred_language: 'Preferred Language',
      },
      placeholders: {
        full_name: 'Your full name',
      },
      validation: {
        required: 'Required',
        required_with_dot: 'Required.',
      },
      choices: {
        yes: 'Yes',
        no: 'No',
      },
      buttons: {
        save: 'Save',
      },
      errors: {
        image_upload: 'Error uploading image:',
        invalid_format: 'Invalid image format',
      },
    },
  },
}
